import {
  DatabaseService,
  OrderCandidate,
  OrderCandidateData,
  OrderCandidateRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getOrderCandidateRepository(
  databaseService: DatabaseService,
): OrderCandidateRepository {
  return getGenericRepository<OrderCandidate, OrderCandidateData>(
    () => DatabaseCollection.ORDER_CANDIDATES,
    databaseService,
  );
}
